module.exports = __webpack_public_path__ + "img/acn_qr.54ceb52f.jpg";